<template>
  <div class="block">

    <el-date-picker
      v-model="value6"
      type="daterange"
      placeholder="选择日期范围"
     
      @change="dateChange"
      :sm="5" :md="2" :lg="1"
      >
    </el-date-picker>
 
    
  </div>
</template>

<script>

  export default {
    name:'fooDate',
    props:{
        parSmelt:""
    },
    data() {
      return {  
        startDate:"",
        endDate:"",
        pickerOptions2: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
              console.log("1")
            },
        
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
                console.log("2")
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
              console.log("3npm")
            }
          }]
        },
        value6: '',
        value7: '',
        val:"",
      };
    },
    methods:{
      dateChange(val) {
            console.log(val);
            //console.log(val.substring(0,10));
            this.val = val;
            this.endDate = val.substring(13);
            this.startDate = val.substring(0,10);
            console.log("父亲组件传递过来的数据",this.parSmelt)
            this.$emit('upup',{"end":this.endDate,"start":this.startDate,"default0":this.val}); //主动触发upup方法，'hehe'为向父组件传递的数据
      },
    
    }
  };
</script>
<style>
.el-date-editor--daterange.el-input{
  width: 95% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Foo.vue